'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DEFAULT_HANDLERS = exports.STYLE_HANDLERS = exports.LINK_HANDLERS = exports.LINE_BREAK = exports.STYLE_SUPERSCRIPT = exports.STYLE_SUBSCRIPT = exports.STYLE_STRONG = exports.STYLE_HIGHLIGHT = exports.STYLE_EM = exports.LINK_INTERNAL = exports.LINK_EXTERNAL = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _uiExternalLink = require('@spp/ui-external-link');

var _uiExternalLink2 = _interopRequireDefault(_uiExternalLink);

var _uiInternalLink = require('@spp/ui-internal-link');

var _uiInternalLink2 = _interopRequireDefault(_uiInternalLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LINK_EXTERNAL = exports.LINK_EXTERNAL = {
    'link:external': function linkExternal(text, key, data) {
        return _react2.default.createElement(
            _uiExternalLink2.default,
            { key: key, href: data.uri },
            text
        );
    }
};

var LINK_INTERNAL = exports.LINK_INTERNAL = {
    'link:internal': function linkInternal(text, key, data) {
        if (data.expandedUri) {
            return _react2.default.createElement(
                _uiInternalLink2.default,
                { key: key, link: data.expandedUri },
                text
            );
        }

        return text;
    }
};

var STYLE_EM = exports.STYLE_EM = {
    'style:em': function styleEm(text, key) {
        return _react2.default.createElement(
            'em',
            { key: key },
            text
        );
    }
};

var STYLE_HIGHLIGHT = exports.STYLE_HIGHLIGHT = {
    'style:highlight': function styleHighlight(text, key) {
        return _react2.default.createElement(
            'mark',
            { key: key },
            text
        );
    }
};

var STYLE_STRONG = exports.STYLE_STRONG = {
    'style:strong': function styleStrong(text, key) {
        return _react2.default.createElement(
            'strong',
            { key: key },
            text
        );
    }
};

var STYLE_SUBSCRIPT = exports.STYLE_SUBSCRIPT = {
    'style:subscript': function styleSubscript(text, key) {
        return _react2.default.createElement(
            'sub',
            { key: key },
            text
        );
    }
};

var STYLE_SUPERSCRIPT = exports.STYLE_SUPERSCRIPT = {
    'style:superscript': function styleSuperscript(text, key) {
        return _react2.default.createElement(
            'sup',
            { key: key },
            text
        );
    }
};
var LINE_BREAK = exports.LINE_BREAK = {
    br: function br(_, key) {
        return _react2.default.createElement('br', { key: key });
    }
};

var LINK_HANDLERS = exports.LINK_HANDLERS = (0, _extends3.default)({}, LINK_EXTERNAL, LINK_INTERNAL);

var STYLE_HANDLERS = exports.STYLE_HANDLERS = (0, _extends3.default)({}, STYLE_EM, STYLE_HIGHLIGHT, STYLE_STRONG, STYLE_SUBSCRIPT, STYLE_SUPERSCRIPT, LINE_BREAK);

var DEFAULT_HANDLERS = exports.DEFAULT_HANDLERS = (0, _extends3.default)({}, LINK_HANDLERS, STYLE_HANDLERS);
//# sourceMappingURL=rules.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/hyperion-stylizr/lib/cjs/rules.js
 ** module id = 267
 ** module chunks = 1
 **/